// Shared token-based song matcher against /api/music-list.
// Used by both the Favorites request button and the "save favorite" flow
// in the CassettePlayer.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

let cachedSongs = null;
let inflight = null;

export function normalize(s) {
  return (s || "")
    .toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

// Load /api/music-list once per session, de-duping concurrent calls.
export async function getSongsCached() {
  if (cachedSongs) return cachedSongs;
  if (inflight) return inflight;
  inflight = axios
    .get(`${API}/music-list`, { timeout: 15000 })
    .then((r) => {
      const list = Array.isArray(r.data?.songs) ? r.data.songs : [];
      cachedSongs = list;
      return list;
    })
    .catch(() => [])
    .finally(() => { inflight = null; });
  return inflight;
}

// Token-based fuzzy match: tokens from raw must ALL appear in
// normalized `${artist} ${title}` haystack. Shortest haystack wins.
export function findSongCode(raw, songs) {
  const nRaw = normalize(raw);
  if (!nRaw) return null;
  const tokens = nRaw.split(" ").filter((t) => t.length >= 2);
  if (tokens.length === 0) return null;

  let best = null;
  let bestLen = Infinity;
  for (const s of songs) {
    const hay = `${normalize(s.artist)} ${normalize(s.title)}`;
    if (!tokens.every((t) => hay.includes(t))) continue;
    if (hay.length < bestLen) {
      best = s;
      bestLen = hay.length;
    }
  }
  return best
    ? { code: best.code, matchedArtist: best.artist, matchedTitle: best.title }
    : null;
}

// Convenience: lookup by raw string, loading music-list as needed.
export async function lookupCode(raw) {
  const songs = await getSongsCached();
  return findSongCode(raw, songs);
}
